export const APP_NAME = window.APP_NAME;
export const API_URL = window.API_URL;
export const APP_URL = window.APP_URL;
//export const STORE_URL = window.STORE_URL;

export const GOOGLE_ANALYTICS_TRACKING_CODE = window.GOOGLE_ANALYTICS_TRACKING_CODE;
export const FACEBOOK_PIXEL_ID = window.FACEBOOK_PIXEL_ID;

export const MIDTRANS_CLIENT_KEY = window.MIDTRANS_CLIENT_KEY;
export const MIDTRANS_SCRIPT_URL = window.MIDTRANS_SCRIPT_URL;
export const URL_SUPPORT_TEAM = window.URL_SUPPORT_TEAM;
export const BANNER_HOMEPAGE_URL = window.BANNER_HOMEPAGE_URL;

export const OIDC_AUTH_URL = window.OIDC_AUTH_URL;
export const OIDC_CLIENT_ID = window.OIDC_CLIENT_ID;
export const OIDC_REDIRECT_URL = window.OIDC_REDIRECT_URL;
export const OIDC_SILENT_REDIRECT_URL = window.OIDC_SILENT_REDIRECT_URL;
export const OIDC_LOGOFF_REDIRECT_URL = window.OIDC_LOGOFF_REDIRECT_URL;